import React from 'react';
import { XIcon } from 'lucide-react';
import { problemas } from '../data/problemas';
import { Emoji } from './Emoji';
export function Problema() {
  return <section className="w-full bg-forest-900 pb-14 pt-6 sm:pb-16" data-id="element-184" data-mp="2cwh6o8vzuiwy">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[760px]" data-id="element-185" data-mp="2ro85ef7nqczf">
        <h2 className="font-display text-[clamp(1.5rem,5.5vw,2.5rem)] font-extrabold leading-[1.08] tracking-tight text-cream" data-id="element-186" data-mp="2mvy98hfy8gop">
          ¿Cuántos domingos más vas a terminar sin saber qué comer mañana?
        </h2>

        <p className="mt-4 font-display text-lg font-bold text-lime-400 sm:text-xl" data-id="element-187" data-mp="2wm9ov18zwebf">
          No terminás nunca.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-cream/75 sm:text-lg" data-id="element-188" data-mp="3ajy9q932blgh">
          Y lo peor no es el hambre… es esa sensación de que querés comer bien,
          organizarte, y salir del ciclo… pero la semana te vuelve a ganar.
        </p>
        <p className="mt-6 font-display text-lg font-extrabold text-lime-500 sm:text-2xl" data-id="element-189" data-mp="1barhy5fp0jit">
          No es falta de ganas. No es falta de recetas. Es falta de un sistema.
        </p>

        <p className="mt-10 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-cream/60 sm:text-sm" data-id="element-190" data-mp="3cp8eqznhkxjy">
          Reconocés alguna de estas situaciones:
        </p>

        <ul className="mt-6 flex flex-col gap-3 text-left" data-id="element-191" data-mp="3lh0laz9e3mj9">
          {problemas.map(problema => <li key={problema} className="flex items-center gap-3 rounded-xl border border-clay/45 bg-clay/[0.14] px-4 py-3.5 sm:gap-4 sm:px-5 sm:py-4" data-id="element-192" data-mp="3qgmxd5dhewqh">
              <XIcon className="h-5 w-5 shrink-0 text-clay sm:h-6 sm:w-6" strokeWidth={3.5} aria-hidden="true" data-id="element-193" data-mp="48dl8askwpij" />
              <span className="font-display text-[14px] font-bold leading-snug text-cream sm:text-[15px]" data-id="element-194" data-mp="26007jz1izw8o">
                {problema}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-[14px] leading-relaxed text-cream/70 sm:text-[15px]" data-id="element-195" data-mp="3dchou5ljo6sk">
          Si te reconociste en aunque sea una de estas, lo que vas a leer ahora
          te cambia la semana para siempre.
        </p>

        <p className="mt-8 font-display text-[clamp(1.25rem,5vw,1.875rem)] font-extrabold italic tracking-tight text-lime-400" data-id="element-196" data-mp="3me8pux553pg3">
          ¿Y si este fuera el último domingo que pasás así?
        </p>

        <p className="mx-auto mt-6 inline-flex max-w-full flex-wrap items-center justify-center gap-2 rounded-full border border-gold/40 bg-forest-800 px-4 py-2 font-display text-[10px] font-extrabold uppercase tracking-[0.12em] text-cream sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-197" data-mp="4xuvbwzbrfv">
          <Emoji symbol="⭐" data-id="element-198" data-mp="4w61y1au70pv" />
          Close The Gap™ — MegaPack Cocina Lista
        </p>
      </div>
    </section>;
}